module.exports = __webpack_public_path__ + "assets/iot-black.52345242.svg";